var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-table',{ref:"table1",attrs:{"fields":_vm.fields,"url":_vm.issueListURL,"per-page":10,"search-placeholder":"Search","show-search-box":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }